// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lriky","social_list":"Footer_social_list__6GHgH","copy_right":"Footer_copy_right__ecNBU"};